/* eslint-disable react/jsx-no-leaked-render */
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FC } from 'react';
import { ProductDetailsThumbnailCarousel } from '@/components/blocks/ProductDetails/ThumbnailCarousel';
import { productDetailsCarouselMainImageSX } from '@/components/blocks/ProductDetails/styles/carouselMainImage';
import { ProductImage } from '@/components/blocks/ProductImage';
import { Ribbon } from '@/data/types/Product';
import { Slide } from '@/data/types/Slide';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';

export type CarouselProps = {
	slides: Slide[];
	choose: (idx: number) => void;
	ribbons: Ribbon[];
	index?: number;
	showFooterControls?: boolean;
	onOpenFullImage?: () => void;
	onClick?: React.MouseEventHandler<unknown>;
};

type Props = CarouselProps & { src: string; alt: string };

export const ProductDetailsCarousel: FC<Props> = ({
	slides,
	choose,
	ribbons,
	index,
	src,
	alt,
	onClick,
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	return (
		<Grid container display={'flex'} flexWrap={'nowrap'} gap={'14px'}>
			<Grid item sx={{ marginRight: '0', width: { md: '10%', lg: '11%' } }} xs={isMobile && 12}>
				<ProductDetailsThumbnailCarousel
					{...{ slides, choose, ribbons: ribbons || [], index, onClick }}
				/>
			</Grid>
			<Grid item xs={5} sx={{ ...productDetailsCarouselMainImageSX, position: 'relative' }}>
				<RenderProductImg
					fullImageRaw={src}
					render={(image) => (
						<ProductImage {...{ src: image, alt, ribbons: ribbons || [], isPDP: true }} />
					)}
				/>
			</Grid>
		</Grid>
	);
};
